/**
 * КОНФИГУРАЦИЯ СТРАНИЦ ПО ОТДЕЛАМ
 *
 * Чтобы добавить новую вкладку для отдела:
 *   1. Создайте компонент страницы в src/features/<название>/
 *   2. Добавьте запись в DEPT_PAGES ниже (или создайте новый ключ для нового отдела)
 *
 * Коды отделов берутся из поля Department.code в базе данных:
 *   energy      — Энергетический участок
 *   asutP       — АСУТП
 *   exploitation — Эксплуатация
 *   emergency   — Аварийная служба
 */

import { lazy } from "react";
import type { LazyExoticComponent, ComponentType } from "react";

export type DeptPage = {
  path: string;       // URL маршрута, например "/directory"
  label: string;      // Подпись в навигации
  component: LazyExoticComponent<ComponentType>;
};

// ─── Конфигурация ────────────────────────────────────────────────────────────

const DEPT_PAGES: Record<string, DeptPage[]> = {

  // ── Энергетический участок ───────────────────────────────────────────────
  energy: [
    {
      path: "/directory",
      label: "Справочник",
      component: lazy(() =>
        import("@/features/directory/directory.page").then((m) => ({ default: m.DirectoryPage }))
      ),
    },
    // Добавить ещё вкладку для energy:
    // {
    //   path: "/energy-schemas",
    //   label: "Схемы",
    //   component: lazy(() => import("@/features/energy/schemas.page").then(m => ({ default: m.SchemasPage }))),
    // },
  ],

  // ── АСУТП ────────────────────────────────────────────────────────────────
  // asutP: [
  //   {
  //     path: "/asut-objects",
  //     label: "Объекты АСУТП",
  //     component: lazy(() => import("@/features/asut/asut.page").then(m => ({ default: m.AsutPage }))),
  //   },
  // ],

  // ── Эксплуатация ─────────────────────────────────────────────────────────
  // exploitation: [
  //   {
  //     path: "/maintenance",
  //     label: "Техобслуживание",
  //     component: lazy(() => import("@/features/maintenance/maintenance.page").then(m => ({ default: m.MaintenancePage }))),
  //   },
  // ],

};

// ─── Вспомогательные функции ─────────────────────────────────────────────────

/** Страницы для конкретного отдела (по коду). */
export function getDeptPages(deptCode?: string | null): DeptPage[] {
  if (!deptCode) return [];
  return DEPT_PAGES[deptCode] ?? [];
}

/** Все страницы всех отделов — нужно router.tsx для регистрации маршрутов. */
export const ALL_DEPT_PAGES: DeptPage[] = Object.values(DEPT_PAGES).flat();
